import { ItemAnalyticsModel, ItemListAnalyticsModel } from '@/@types/client-api';
import { AnalyticsEventName, AnalyticsContext } from './constants';
import { trackEvent } from './utils';
import { ConvertItemAnalyticsModelBase, createTransactionId } from './analyticsUtils';
import { trackAddToCart, trackBeginCheckoutEvent, trackPurchaseEvent } from './ecommerce';

export const trackMoreLikeThisEvent = (itemAnalyticsModel?: ItemAnalyticsModel) => {
  if (itemAnalyticsModel) {
    trackEvent({
      eventName: AnalyticsEventName.MoreLikeThis,
      parameters: {
        context: AnalyticsContext.Cards,
        items: [ConvertItemAnalyticsModelBase(itemAnalyticsModel)]
      },
    });
  }
};

export const trackCardLaunchAProgramEvent = (
  itemAnalyticsModel?: ItemAnalyticsModel,
  context?: AnalyticsContext,
  isZeroDollar?: boolean,
  itemListAnalyticsModel?: ItemListAnalyticsModel,
  isStoredInstrument?: boolean,
  itemIndex?: number
) => {
  if (itemAnalyticsModel) {
    if (isZeroDollar) {
      const transactionId = createTransactionId('WEBZERO');
      trackAddToCart(itemAnalyticsModel, context, transactionId, itemListAnalyticsModel);
      trackBeginCheckoutEvent(itemAnalyticsModel, context, transactionId, itemListAnalyticsModel);
      trackPurchaseEvent(
        itemAnalyticsModel,
        context,
        transactionId,
        itemListAnalyticsModel,
        isStoredInstrument
      );
      trackZeroPurchaseValueEvent(itemAnalyticsModel, context, itemListAnalyticsModel);
    }

    trackEvent({
      eventName: AnalyticsEventName.LaunchAProgram,
      parameters: {
        context: context || '',
        items: [
          ConvertItemAnalyticsModelBase(itemAnalyticsModel, itemListAnalyticsModel, itemIndex)
        ]
      },
    });
  }
};

export const trackCardReadNowEvent = (itemAnalyticsModel?: ItemAnalyticsModel) => {
  if (itemAnalyticsModel) {
    trackEvent({
      eventName: AnalyticsEventName.ReadNow,
      parameters: {
        context: AnalyticsContext.Cards,
        items: [ConvertItemAnalyticsModelBase(itemAnalyticsModel)]
      },
    });
  }
};

export const trackCardRequestCreditEvent = (
  itemAnalyticsModel?: ItemAnalyticsModel,
  context?: AnalyticsContext
) => {
  if (itemAnalyticsModel) {
    trackEvent({
      eventName: AnalyticsEventName.RequestCreditStart,
      parameters: {
        context: context || '',
        items: [ConvertItemAnalyticsModelBase(itemAnalyticsModel)]
      },
    });
  }
};

export const trackZeroPurchaseValueEvent = (
  itemAnalyticsModel?: ItemAnalyticsModel,
  context?: AnalyticsContext,
  itemListAnalyticsModel?: ItemListAnalyticsModel
) => {
  if (itemAnalyticsModel) {
    trackEvent({
      eventName: AnalyticsEventName.ZeroPurchaseValue,
      parameters: {
        context: context || '',
        value: itemAnalyticsModel?.listPrice || 0,
        currency: itemAnalyticsModel?.currency || '',
        items: [ConvertItemAnalyticsModelBase(itemAnalyticsModel, itemListAnalyticsModel)],
        purchase_source: 'WithRequest'
      },
    });
  }
};

